module.exports = __webpack_public_path__ + "static/plume-poster-edfc17b7b0affcbacd2e25e16c470486.jpg";